import MuiLinearProgress from "@mui/material/LinearProgress";

export const LinearProgress = (props) => {
  return <MuiLinearProgress {...props} />;
};
